var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsDate, IsEnum, IsNumber, IsObject, IsOptional, IsString, IsUrl } from 'class-validator';
var HighlightType;
(function (HighlightType) {
    HighlightType["LAUNCH"] = "LAUNCH";
    HighlightType["MILESTONE"] = "MILESTONE";
    HighlightType["POST"] = "POST";
    HighlightType["TALK"] = "TALK";
    HighlightType["VIDEO"] = "VIDEO";
    HighlightType["AWARD"] = "AWARD";
})(HighlightType || (HighlightType = {}));
export const MANFREDITE_HIGHLIGHT_TYPES = Object.keys(HighlightType);
export class ManfrediteHighlightDto {
    static _OPENAPI_METADATA_FACTORY() {
        return { type: { required: true, type: () => Object, nullable: true }, title: { required: true, type: () => Object }, description: { required: false, type: () => Object }, category: { required: false, type: () => Object }, date: { required: true, type: () => Date }, techIds: { required: false, type: () => [Number] }, url: { required: false, type: () => String, nullable: true }, logoId: { required: false, type: () => Number } };
    }
}
__decorate([
    Expose(),
    IsEnum(HighlightType),
    __metadata("design:type", Object)
], ManfrediteHighlightDto.prototype, "type", void 0);
__decorate([
    Expose(),
    IsObject(),
    __metadata("design:type", Object)
], ManfrediteHighlightDto.prototype, "title", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsObject(),
    __metadata("design:type", Object)
], ManfrediteHighlightDto.prototype, "description", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsObject(),
    __metadata("design:type", Object)
], ManfrediteHighlightDto.prototype, "category", void 0);
__decorate([
    Expose(),
    IsDate(),
    Type(() => Date),
    __metadata("design:type", Date)
], ManfrediteHighlightDto.prototype, "date", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsArray(),
    __metadata("design:type", Array)
], ManfrediteHighlightDto.prototype, "techIds", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    IsUrl(),
    __metadata("design:type", Object)
], ManfrediteHighlightDto.prototype, "url", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsNumber(),
    __metadata("design:type", Number)
], ManfrediteHighlightDto.prototype, "logoId", void 0);
//# sourceMappingURL=manfredite-highlight.dto.js.map